// Module
var code = `<!-- blProse — blog paragraphs.
     Data shape: { content: [ "paragraph (inline HTML)", ... ] } -->
{{#content}}<p>{{.}}</p>{{/content}}
`;
// Exports
module.exports = code;